export const captureFrame = (props) => {
  const video = props.videoRef.current;
  const canvas = props.canvasRef.current;
  if (video && canvas) {
    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight; 
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataURL = canvas.toDataURL("image/png");
    return imageDataURL;
  }
};

export const formatDate = (isoString) => {
  const date = new Date(isoString);
  
  const year = date.getFullYear();
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" }); // e.g., "Mar"
  const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";

  return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
};



export const timeStringToSeconds=(timeString) =>{
  const parts = timeString.split(":").map(Number); // ['00', '01', '00'] → [0, 1, 0]

  let seconds = 0;

  if (parts.length === 3) {
    // hh:mm:ss
    seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
  } else if (parts.length === 2) {
    // mm:ss
    seconds = parts[0] * 60 + parts[1];
  } else if (parts.length === 1) {
    // ss
    seconds = parts[0];
  }

  return seconds;
}

export const toTitleCase= (str) => {
  return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}